export default "__VITE_ASSET__DQRSjsyS__";